const COORD_PAIR_RE = /^-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?$/;

function isViewerAddressPlaceholder(addr: string): boolean {
  const t = addr.trim();
  if (t.endsWith("…") || t.endsWith("\u2026")) return true;
  return /^opening report/i.test(t) || /^loading terrain/i.test(t) || /^scanning/i.test(t);
}

/**
 * US-style addresses (`"1738 Oak Dr, Rhinebeck NY 12572"` → `"1738 Oak Dr"`).
 * Keeps placeholders, coordinate pairs, and single-line addresses as-is.
 */
export function abbreviatedStreetLine(address: string): string {
  const t = address.trim();
  if (!t.length) return t;
  if (isViewerAddressPlaceholder(t)) return t;
  if (COORD_PAIR_RE.test(t)) return t;

  const comma = t.indexOf(",");
  if (comma <= 0) return t;
  const head = t.slice(0, comma).trim();
  return head.length > 0 ? head : t;
}
